import { CookiesStore } from '../store/cookies-store';
export class CookiesService {
    constructor() {
        var _a, _b;
        this.listeners = [];
        this.onStateChanged = ({ isCookiesAccepted }, prevState) => {
            var _a, _b;
            const containerClassList = (_a = this.container) === null || _a === void 0 ? void 0 : _a.classList;
            const backdropClassList = (_b = this.backdrop) === null || _b === void 0 ? void 0 : _b.classList;
            if (isCookiesAccepted) {
                this.remove();
            }
            else {
                containerClassList === null || containerClassList === void 0 ? void 0 : containerClassList.add('active');
                backdropClassList === null || backdropClassList === void 0 ? void 0 : backdropClassList.add('active', 'cookies');
            }
        };
        this.onCookiesAccept = () => {
            CookiesStore.getState().acceptCookies();
        };
        this.onCookiesDecline = () => {
            var _a, _b;
            (_a = this.container) === null || _a === void 0 ? void 0 : _a.classList.remove('active');
            (_b = this.backdrop) === null || _b === void 0 ? void 0 : _b.classList.remove('active', 'cookies');
        };
        this.container = document.querySelector('.cookies');
        this.acceptBtn = (_a = this.container) === null || _a === void 0 ? void 0 : _a.querySelector('.cookies-button-accept');
        this.denyBtn = (_b = this.container) === null || _b === void 0 ? void 0 : _b.querySelector('.cookies-button-deny');
        this.backdrop = document.querySelector('.backdrop');
    }
    init() {
        var _a, _b;
        this.onStateChanged(CookiesStore.getState());
        this.listeners.push(CookiesStore.subscribe(this.onStateChanged));
        (_a = this.acceptBtn) === null || _a === void 0 ? void 0 : _a.addEventListener('pointerdown', this.onCookiesAccept);
        (_b = this.denyBtn) === null || _b === void 0 ? void 0 : _b.addEventListener('pointerdown', this.onCookiesDecline);
    }
    remove() {
        var _a, _b;
        this.listeners.map((unsubscribe) => unsubscribe());
        (_a = this.container) === null || _a === void 0 ? void 0 : _a.remove();
        (_b = this.backdrop) === null || _b === void 0 ? void 0 : _b.classList.remove('active', 'cookies');
    }
}
